(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lgm-sibadge"] && !Shopify.designMode) return;
  try {
    (function () {
    function rand(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }

    function initBadge(el) {
      if (el.dataset.lgmInit) return;
      el.dataset.lgmInit = '1';
      var countEl = el.querySelector('.lgm-sibadge__count');
      if (!countEl) return;
      countEl.dataset.lgmN = rand(80, 160);
      countEl.textContent = countEl.dataset.lgmN;
    }

    function tickAll() {
      document.querySelectorAll('[data-lgm-viewing][data-lgm-init]').forEach(function (el) {
        var countEl = el.querySelector('.lgm-sibadge__count');
        if (!countEl) return;
        var n = Math.min(160, Math.max(80, parseInt(countEl.dataset.lgmN) + rand(-2, 2)));
        countEl.dataset.lgmN = n;
        countEl.textContent = n;
      });
    }

    function scan(root) {
      (root || document).querySelectorAll('[data-lgm-viewing]').forEach(initBadge);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); setInterval(tickAll, 5000); });
    } else {
      scan();
      setInterval(tickAll, 5000);
    }

    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-lgm-viewing]')) initBadge(node);
          scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
